import FuncUtil from '../util/FuncUtil';
import {isObservable,toJS} from 'mobx';
export default function(proxyName){

    //输出方法名
    function printMethodName(name,originFun){
        let methodName = FuncUtil.getFnName(originFun);
        console.log(`${name} 方法名 ${methodName}`);
    }

    //输出参数名
    function printArgument(name,argsNames,args){
        let i,length=args.length;
        for(i=0;i<length;i++){
            console.log(`${name} 参数${i+1} ${argsNames[i]}:`,isObservable(args[i])?toJS(args[i]):args[i]);
        }
    }

    //打印函数执行结果和消耗时间
    function printMethodExeTime(name,startTime,endTime,result){
        let costTime = endTime - startTime;
        console.log(`${name} 函数执行结果 `,result);
        console.log(`${name} 函数消耗时间 `,`${costTime}ms`);
    }
    
    // 包裹方法，在原方法前后增加执行方法
    function proxyWrapped(originFun){
        let argsNames = FuncUtil.getArgs(originFun);
        printMethodName(proxy.name,originFun);
        //判断是否是同步函数
        if(FuncUtil.isAsyncFunction(originFun)){
            return async function(){
                printArgument(proxy.name,argsNames,arguments);
                const startTime = new Date().getTime();
                const result = await originFun.apply(this, arguments);
                const endTime = new Date().getTime();
                printMethodExeTime(proxy.name,startTime,endTime,result);
                return result;
            }
        }else{
            return function(){
                printArgument(proxy.name,argsNames,arguments);
                const startTime = new Date().getTime();
                const result = originFun.apply(this, arguments);
                const endTime = new Date().getTime();
                printMethodExeTime(proxy.name,startTime,endTime,result);
                return result;
            }
        }
        
    }
    
    var proxy = {
        // 添加被代理方法，参数a为被代理方法，参数b为目标对象
        add : function(a, b){
            var funName, index;
            // 不传对象时默认为window对象
            b = b || window;
            // 判断参数a类型，如果为正则表达式
            if(typeof a == "object" && a.test){
                // 替换所以满足正则表达式的方法
                Object.getOwnPropertyNames(b.__proto__).forEach((methodName)=>{
                    if(a.test(methodName)){
                        b[methodName] = proxyWrapped(b[methodName]);
                    }
                });
            }else if(typeof b == "function" && typeof a =="string"){
               b[a] = proxyWrapped(b[a]);
            }
            return this;
        },
        // 默认标识
        name : '代理方法'
    }

    if(typeof proxyName == 'string'){
        proxy.name = proxyName;
    }
    
    return proxy;
}